import React, { useState } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const subjects = [
  'General Experience',
  'Flight Booking',
  'Hotel Booking',
  'Visa Assistance',
  'Holiday Package',
  'Customer Service',
  'Website',
  'Other'
];

function StarRating({ value, onChange }) {
  const [hovered, setHovered] = useState(0);

  return (
    <div style={{ display: 'flex', gap: 6 }}>
      {[1, 2, 3, 4, 5].map(function(star) {
        var filled = star <= (hovered || value);
        return (
          <button
            key={star}
            type="button"
            onClick={function() { onChange(star); }}
            onMouseEnter={function() { setHovered(star); }}
            onMouseLeave={function() { setHovered(0); }}
            style={{
              background: 'none', border: 'none',
              cursor: 'pointer', padding: 2,
              fontSize: '2rem',
              color: filled ? '#f59e0b' : '#d1d5db',
              transform: filled ? 'scale(1.15)' : 'scale(1)',
              transition: 'color 0.15s, transform 0.15s'
            }}
            aria-label={'Rate ' + star + ' stars'}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}

const ratingLabels = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Very Good', 5: 'Excellent' };
const ratingColors = { 1: '#ef4444', 2: '#f97316', 3: '#eab308', 4: '#84cc16', 5: '#22c55e' };

export default function FeedbackPage() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '',
    subject: 'General Experience',
    rating: 0, message: ''
  });
  const [status, setStatus]   = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.rating) {
      setStatus('error');
      setErrorMsg('Please select a star rating before submitting.');
      return;
    }
    setStatus('submitting');
    setErrorMsg('');
    try {
      await api.post('/feedback', form);
      setStatus('success');
      setForm({ name: '', email: '', phone: '', subject: 'General Experience', rating: 0, message: '' });
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.response?.data?.message || 'Something went wrong. Please try again.');
    }
  }

  return (
    <Layout>
      {/* HERO */}
      <div style={{
        background: 'linear-gradient(135deg, var(--bj-espresso) 0%, #1e3f6b 100%)',
        padding: '64px 0 56px', position: 'relative', overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', top: -60, right: -60, width: 260, height: 260, borderRadius: '50%', background: 'rgba(63,114,175,0.1)', pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative' }}>
          <span className="eyebrow" style={{ color: 'var(--bj-sand)' }}>Your Voice Matters</span>
          <h1 style={{ color: '#fff', margin: '10px 0 14px', fontSize: 'clamp(1.8rem, 4vw, 2.8rem)' }}>
            Share Your Feedback
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', maxWidth: 520, lineHeight: 1.75, margin: 0 }}>
            We are committed to delivering exceptional travel experiences. Tell us how we did —
            your feedback directly shapes how we serve you better.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>

          {status === 'success' ? (
            <div style={{
              textAlign: 'center', padding: '56px 32px',
              background: '#fff', borderRadius: 20,
              boxShadow: '0 8px 32px rgba(17,45,78,0.08)'
            }}>
              <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>🤝</div>
              <h2 style={{ margin: '0 0 12px' }}>Thank you for your feedback</h2>
              <p style={{ opacity: 0.7, maxWidth: 440, margin: '0 auto 28px', lineHeight: 1.75 }}>
                Your response has been received and shared with our team. We genuinely appreciate
                you taking the time to help us improve.
              </p>
              <button
                className="btn btn-primary"
                onClick={function() { setStatus(null); }}
                style={{ justifyContent: 'center' }}
              >
                Submit Another Response
              </button>
            </div>
          ) : (
            <div style={{
              background: '#fff', borderRadius: 20,
              boxShadow: '0 8px 32px rgba(17,45,78,0.08)',
              overflow: 'hidden'
            }}>
              {/* Form header */}
              <div style={{
                padding: '28px 32px',
                borderBottom: '1px solid var(--bj-sand)',
                display: 'flex', alignItems: 'center', gap: 14
              }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: 'var(--bj-clay)' + '18',
                  display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '1.4rem', flexShrink: 0
                }}>
                  💬
                </div>
                <div>
                  <h3 style={{ margin: 0 }}>Feedback Form</h3>
                  <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.6 }}>
                    All fields marked * are required. Takes less than 2 minutes.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} style={{ padding: '28px 32px' }}>

                {/* Personal info */}
                <div className="form-grid" style={{ marginBottom: 20 }}>
                  <div className="form-field">
                    <label>Full Name *</label>
                    <input
                      name="name" required
                      value={form.name} onChange={handleChange}
                      placeholder="Your full name"
                    />
                  </div>
                  <div className="form-field">
                    <label>Email Address *</label>
                    <input
                      name="email" type="email" required
                      value={form.email} onChange={handleChange}
                      placeholder="your@email.com"
                    />
                  </div>
                  <div className="form-field">
                    <label>Phone Number <span style={{ opacity: 0.5, fontWeight: 400 }}>(optional)</span></label>
                    <input
                      name="phone" type="tel"
                      value={form.phone} onChange={handleChange}
                      placeholder="+221 XX XXX XXXX"
                    />
                  </div>
                  <div className="form-field">
                    <label>Feedback Subject *</label>
                    <select name="subject" value={form.subject} onChange={handleChange}>
                      {subjects.map(function(s) { return <option key={s}>{s}</option>; })}
                    </select>
                  </div>
                </div>

                {/* Rating */}
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, marginBottom: 10 }}>
                    Overall Rating *
                  </label>
                  <div style={{
                    background: 'var(--bj-cream-soft)',
                    borderRadius: 12, padding: '20px 24px',
                    display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap'
                  }}>
                    <StarRating
                      value={form.rating}
                      onChange={function(r) { setForm({ ...form, rating: r }); }}
                    />
                    {form.rating > 0 && (
                      <span style={{
                        fontWeight: 700, fontSize: '1rem',
                        color: ratingColors[form.rating]
                      }}>
                        {ratingLabels[form.rating]}
                      </span>
                    )}
                    {!form.rating && (
                      <span style={{ opacity: 0.45, fontSize: '0.88rem' }}>
                        Click to rate your experience
                      </span>
                    )}
                  </div>
                </div>

                {/* Message */}
                <div className="form-field" style={{ marginBottom: 24 }}>
                  <label>Your Feedback *</label>
                  <textarea
                    name="message" required rows={5}
                    value={form.message} onChange={handleChange}
                    placeholder="Tell us about your experience — what went well, what could be better, and anything else you'd like us to know..."
                  />
                </div>

                {/* Privacy note */}
                <p style={{ fontSize: '0.78rem', opacity: 0.5, marginBottom: 20, lineHeight: 1.65 }}>
                  Your feedback is stored securely and reviewed by our management team. We may reach out
                  to you on the contact details provided if we need clarification.
                </p>

                {status === 'error' && (
                  <p className="form-message error" style={{ marginBottom: 16 }}>{errorMsg}</p>
                )}

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={status === 'submitting'}
                  style={{ width: '100%', justifyContent: 'center', padding: '14px' }}
                >
                  {status === 'submitting' ? 'Submitting…' : 'Submit Feedback'}
                </button>
              </form>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}